import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatRecurrence(recurrence) {
  if (!recurrence || recurrence === '-') return '-';
  // Convert to title case: "none" -> "None", "daily" -> "Daily", etc.
  return recurrence.charAt(0).toUpperCase() + recurrence.slice(1).toLowerCase();
}

export function truncateText(text, maxLength = 60) {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
}

export function formatStatus(status) {
  if (!status) return '';
  // Handle specific status mappings
  if (status === 'completed' || status === 'approved') return 'Completed';
  if (status === 'pending' || status === 'in_progress') return 'Pending';
  if (status === 'submitted_for_review') return 'Submitted for Review';
  if (status === 'rejected_in_review') return 'Rejected';
  if (status === 'scheduled' || status === 'upcoming') return 'Upcoming';
  if (status === 'ongoing') return 'Ongoing';
  
  // Convert to proper title case (e.g., "submitted_for_review" -> "Submitted For Review")
  return status
    .replace(/_/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}